import { FC } from 'react';

import { FontWeightEnum, Heading, HeadingEnum, LinkTypesEnum } from '@argenta/react-ui';
import { Trans } from '@lingui/react';

import { I18nLink } from '../../components/I18nLink';
import { VacanciesRoute } from '../../routers/AppRouter/routes';

import './VacancyNotFound.styles.scss';

export const VacancyNotFound: FC = () => (
  <div className="argnt-vacancy-not-found">
    <Heading type={HeadingEnum.H2} fontWeight={FontWeightEnum.BOLD}>
      <Trans id="vacancyNotFound.title" components={{}} values={{}} />
    </Heading>
    <img src={`${process.env.PUBLIC_URL}/assets/images/404.png`} alt="" />
    <I18nLink
      to={VacanciesRoute.SEARCH_VACANCIES}
      type={LinkTypesEnum.PRIMARY}
      className="argnt-vacancy-not-found__link"
    >
      <Trans id="vacancyNotFound.link" components={{}} values={{}} />
    </I18nLink>
  </div>
);
